import React from 'react'
import "./Main_wallet_card.css"
import Main_wallet_card_lottie from '../../../../animations/main_wallet_card_lottie/Main_wallet_card_lottie'

function Main_wallet_card({animationData}) {
    return (
        <>
            <section className='Main_wallet_card'>
                <div className="card_lottie_holder">
                    <Main_wallet_card_lottie animationData={animationData} />
                </div>

                <div className="contant_holder">
                    <div className="text_holder">
                        <h6>TopUp Amount</h6>
                    </div>

                    <div className="count_holder">
                        <h5>756.00</h5>
                        <p>Points</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main_wallet_card